<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="hook">
<h1>Hook</h1>
<p>Amidst a raging supercell, a sub-surface mining skiff or Skimmer becomes the target of a rogue group intent on securing the technology. Meanwhile, the youthful crew onboard becomes aware of the broader plan for the Skimmers and must find a way to evade capture. Isolated and with help too far away to reach them in time, the crew must act to save themselves, their Skimmer, and the technology.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?302e3527